import { TagGroup } from '@cad-arc';
import { CautionsTabPill } from '@mark43/cad-api';
import { CautionPill } from '../../../../cautions/components/caution-pill';

export const CautionPills = ({
    cautions,
    size,
}: {
    cautions: CautionsTabPill[];
    size?: 'sm' | 'md';
}) => {
    return (
        <TagGroup
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {cautions.map((caution, idx) => {
                return <CautionPill key={idx} caution={caution} size={size} />;
            })}
        </TagGroup>
    );
};
